<style lang="scss" scoped>
.table {
  background: #fff;
  height: 300px;
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #dcdfe6;
  min-height: 500px;
}
/deep/ {
  .el-input {
    width: 400px;
    margin-right: 5px;
  }
  .el-input .el-input__count .el-input__count-inner {
    background: transparent;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-checkbox {
    margin-top: 20px;
  }
}
.line {
  min-height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  display: flex;
  > span {
    display: inline-block;
    width: 140px;
    text-align: left;
    margin-right: 10px;
  }
  .tip {
    width: 240px;
    color: #606266;
  }
}
p {
  color: #606266;
  margin-left: 130px;
  font-size: 14px;
  margin-top: -15px;
}
.bor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 920px;
  padding: 0 15px;
}
.bor2 {
  width: 200px;
}
.shaixuan {
  height: 45px;
  background: #606266;
  width: 100%;
  color: #fff;
  line-height: 45px;
  display: flex;
  > div:nth-child(1) {
    width: 80px;
    height: 100%;
    background: #17cfb8;
    text-align: center;
  }
  > div:nth-child(2) {
    flex: 1;
    height: 100%;
    justify-content: space-around;
    display: flex;
    margin-left: 35px;
    margin-right: 60px;
  }
}
.wrap {
  min-height: 500px;
  padding: 30px 20px;
  box-sizing: border-box;
}
.blue {
  color: #5e6166;
  display: inline-block;
  border: 1px solid #dcdfe6;
  padding: 10px 15px;
  > span {
    color: #0091ff;
    margin-left: 10px;
  }
}
.qrcode {
  width: 300px;
  height: 300px;
  margin: 20px auto 0;
  + div {
    text-align: center;
    font-size: 20px;
    color: #000;
  }
}
</style>

<template>
  <div>
    <alert>
      <div>1、公众号分为订阅号、服务号，根据微信公众平台的接口规则，不同类型的公众号可使用不同的功能；如果是认证的服务号则下面的全部功能均可使用！</div>
      <div>2、认证：在公众平台后台提交企业资料并向微信支付300元的认证费用并审核通过，叫公众号认证；如果公众号没有认证则只能使用下面的部分功能！</div>
      <div>3、该公众号（上海零动）是已认证的服务号，下面的全部功能均可使用！</div>
    </alert>
    <div class="table">
      <div class="line">
        <span>群发主题</span>
        <el-input v-model="form.name" maxlength="40" show-word-limit></el-input>
        <span class="tip">仅作区分用途，不会在粉丝端显示</span>
      </div>
      <div class="line">
        <span>设置群发对象</span>
        <div v-if="type=='edit'" class="bor bor2">{{form.type == 1 ? '全部粉丝' : '分组粉丝'}}</div>
        <el-select v-else v-model="form.type" placeholder="请选择">
          <el-option label="全部粉丝" :value="1">全部粉丝</el-option>
          <el-option label="分组粉丝" :value="2">分组粉丝</el-option>
        </el-select>
        <el-button
          v-show="(type == 'creat' && form.type == 2) || (type == 'edit' && form.type == 2 && (form.status == 1 || form.status == 4))"
          type="text"
          icon="el-icon-circle-plus-outline"
          @click="() => {this.dialogVisible = true}"
        >选择标签/分组</el-button>
      </div>
      <div class="line" v-show="form.type == 2">
        <span></span>
        <div class="bor">
          <span v-for="item in checkLists" :key="item.customTagId" class="mr20">{{item.name}}</span>
        </div>
      </div>
      <div
        class="line"
        v-show="form.type == 1 || (type == 'edit' && form.status != 1 && form.status != 2 && form.status != 4)"
      >
        <span>设置定时群发时间</span>
        <el-date-picker v-model="form.pushDate" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </div>
      <wxEditor v-if="form.type" ref="wxEditor" reply="1"></wxEditor>
    </div>
    <div class="clearfix alignc mt30">
      <el-button v-if="type== 'creat'" type="primary" @click="save">保存</el-button>
      <el-button v-else type="primary" @click="save2">保存</el-button>
    </div>
    <el-dialog title="选择标签/分组" width="1182px" :visible.sync="dialogVisible" :show-close="false">
      <div class="shaixuan">
        <div class="fl pointer" @click="all">全部</div>
        <div class="fr">
          <span class="pointer" v-for="i in letter" :key="i" @click="changeLetter(i)">{{i}}</span>
        </div>
      </div>
      <div class="wrap">
        <el-checkbox-group v-model="checkList" @change="changeTag">
          <el-checkbox
            v-for="(item,index) in tagList"
            :key="item.customTagId"
            :label="item.customTagId"
          >
            <span class="blue">
              {{item.name}}
              <span>{{item.followers}}</span>
            </span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </el-dialog>
    <el-dialog title width="778px" :visible.sync="dialogVisible2">
      <div class="alignc pb30">
        <img :src="qrcode" alt class="qrcode" />
        <div>扫码获知推送通知</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wxEditor from '@/components/wxEditor';
import utils from '@/utils.js';
import { nextTick } from 'q';
export default {
  components: {
    wxEditor,
  },
  computed: {},
  props: ['id'],
  watch: {
    'form.name': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 40) {
          this.form.name = oldval;
        }
      },
    },
  },
  data() {
    return {
      date: '',
      value: '',
      qrcode: '',
      timer: '',
      type: this.$route.path.split('/')[5],
      form: {
        name: '',
        type: '',
        replyType: '',
        pushDate: '',
      },
      dialogVisible: false,
      dialogVisible2: false,
      tagList: [],
      allList: [],
      checkList: [],
      checkLists: [],
      letter: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
    };
  },
  async mounted() {
    let res = await this.$http.get(`/api/${this.id}/custom-tags`);
    console.log(res);
    this.allList = res;
    res.forEach(item => {
      this.tagList.push(...item.customTags);
    });
    if (this.type == 'edit') {
      let res2 = await this.$http.get(
        `/api/${this.id}/group-message/${this.$route.query.gmid}`,
      );
      console.log(res2);
      this.checkLists = res2.customTags;
      this.checkList = res2.customTags.map(v => {
        return v.customTagId;
      });
      this.form = res2;
      this.$nextTick(() => {
        this.$refs.wxEditor.setData(res2);
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // ...
    console.log(this.timer);
    if (this.timer) {
      clearInterval(this.timer);
    }
    next();
  },
  methods: {
    all() {
      this.tagList = [];
      this.allList.forEach(item => {
        this.tagList.push(...item.customTags);
      });
    },
    changeTag(val) {
      this.checkLists = this.tagList.filter(v => {
        return val.indexOf(v.customTagId) != -1;
      });
    },
    changeLetter(i) {
      let arr = this.allList.filter(item => {
        return item.prifex == i;
      });
      if (arr.length) {
        this.tagList = arr[0].customTags;
      } else {
        this.tagList = [];
      }
    },
    async save() {
      let form = this.form;
      if (!form.name) {
        this.$message.error('请填写群发主题');
        return;
      } else if (!form.type) {
        this.$message.error('请选择群发对象');
        return;
      } else if (form.type == 1 && !form.pushDate) {
        this.$message.error('请设置群发时间');
        return;
      } else if (form.type == 2 && !this.checkList.length) {
        this.$message.error('请选择分组标签');
        return;
      }
      let res = this.$refs.wxEditor.postData();
      if (
        (res.replyType == 1 && !JSON.parse(res.text)[0]) ||
        (res.replyType != 1 && !res.materialid)
      ) {
        this.$message.error('请选择发送内容');
        return;
      }
      if (res.replyType == 1) {
        form.text = res.text;
      } else {
        form.materialid = res.materialid;
      }
      form.replyType = res.replyType;
      if (form.type == 1) {
        form.pushDate = this.moment(form.pushDate);
      } else {
        form.customTags = this.checkList;
      }
      let res2 = await this.$http.post(`/api/${this.id}/group-message`, form);
      console.log(res2);
      if (res2.notifyQRCode) {
        this.qrcode = res2.notifyQRCode;
        this.dialogVisible2 = true;
        this.timeout(res2.groupMessageId);
      } else if (res2) {
        this.$message.success('保存成功');
        this.$router.back(-1);
      }
    },
    async timeout(id) {
      this.timer = setInterval(async () => {
        let res = await this.$http.get(
          `/api/${this.id}/group-message/${id}/notify-qrcode/status`,
        );
        if (res.scan) {
          clearInterval(this.timer);
          this.$message.success('扫码成功');
          this.$router.back(-1);
        }
      }, 2000);
    },
    async save2() {
      let form = this.form;
      if (!form.name) {
        this.$message.error('请填写群发主题');
        return;
      } else if (form.type == 2 && !this.checkList.length) {
        this.$message.error('请选择分组标签');
        return;
      } else if ((form.status == 3 || form.status == 5) && !form.pushDate) {
        this.$message.error('请设置群发时间');
        return;
      }
      let res = this.$refs.wxEditor.postData();
      if (
        (res.replyType == 1 && !JSON.parse(res.text)[0]) ||
        (res.replyType != 1 && !res.materialid)
      ) {
        this.$message.error('请选择发送内容');
        return;
      }
      if (res.replyType == 1) {
        form.text = res.text;
      } else {
        form.materialid = res.materialid;
      }
      form.replyType = res.replyType;
      form.pushDate = form.pushDate ? this.moment(form.pushDate) : '';
      form.customTags = this.checkList;
      let res2 = await this.$http.put(
        `/api/${this.id}/group-message/${this.$route.query.gmid}`,
        form,
      );
      console.log(res2);
      if (res2) {
        this.$message.success('修改成功');
        this.$router.back(-1);
      }
    },
  },
};
</script>
